import React from 'react'
import { RouteProps } from 'react-router-dom'

import RegisterTemplate from '../../../../templates/Register'

import { useUpdateSlotProps } from './useProps'

const UpdateSlotPage: React.FC<RouteProps> = () => {
  const templateProps = useUpdateSlotProps()

  return <RegisterTemplate {...templateProps} />
}

export default UpdateSlotPage
